import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { PartnerService } from '../../services/partner.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-laboratory-test',
  templateUrl: './laboratory-test.component.html',
  styleUrls: ['./laboratory-test.component.scss']
})
export class LaboratoryTestComponent implements OnInit {
  formSubmitAttempt: boolean = false;
  isPageEditable: boolean = true;
  statusMessage: string = "Loading data please wait...";
  laboratoryTestList: Observable<any>;
  isDisplayAddRecord: boolean = false;
  isDisplayRecordList: boolean = true;
  isDisplayUpdateRecord: boolean = false;
  laboratoryProductList: Observable<any>;
  laboratoryGroupItems: any;
  selectedOption: any = 0;
  activeSubscriptionOption : boolean = true;
  showFamilyMember : boolean = true;
  public isSlide: boolean = false;
  public itemForm: FormGroup;
  familymembers: any = 0;
  fileToUpload: File = null;
  constructor(private _partnerService: PartnerService, private router: Router, private fb: FormBuilder) {
    this.itemForm = fb.group({
      productId: ['',],
      productTypeId: ['',],
      name: ['', [Validators.required]],
      description: ['', []],
      uniqueCode: ['', []],
      packetSize: ['', []],
      unitType: ['', []],
      familymembers: []
    })
    this.laboratoryGroupItems = [{
      value: 0,
      description: 'All'
    },
    {
      value: 1,
      description: 'Laboratory'
    }, {
      value: 2,
      description: 'Diagnostics'
    },
    {
      value: 3,
      description: 'Pharmacy'
    }, {
      value: 4,
      description: 'Specialization Referral'
    },
    {
      value: 5,
      description: 'Physical Examination Referral'
    }
  ]
  console.log('constructor');

  }

  ngOnInit() {
    this.getLaboratoryTest();
  }
  getLaboratoryTest() {
    this._partnerService.getLaboratoryTest()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            if(employeeData.response){
              this.laboratoryTestList = employeeData.response.productList;
              this.laboratoryProductList = employeeData.response.productList;
            }
          }
          console.log(this.laboratoryTestList);
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }

  showAdd() {
    this.isDisplayAddRecord = true;
    this.isDisplayRecordList = false;
    this.isDisplayUpdateRecord = false;
  }

  editTest(itemDetails) {
    this.isDisplayAddRecord = false;
    this.isDisplayRecordList = false;
    this.isDisplayUpdateRecord = true;
    this.itemForm.controls['productId'].setValue(itemDetails.productId);
    this.itemForm.controls['productTypeId'].setValue(itemDetails.productTypeId);
    this.itemForm.controls['name'].setValue(itemDetails.name);
    this.itemForm.controls['description'].setValue(itemDetails.description);
    this.itemForm.controls['uniqueCode'].setValue(itemDetails.uniqueCode);
    this.itemForm.controls['packetSize'].setValue(itemDetails.packetSize);
    this.itemForm.controls['unitType'].setValue(itemDetails.unitType);
  }

  cancelForm() {
    this.isDisplayAddRecord = false;
    this.isDisplayRecordList = true;
    this.isDisplayUpdateRecord = false;
    this.getLaboratoryTest()
  }

  addRecord(record) {
    this.formSubmitAttempt = true;
    var date = new Date();
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    record.value.productTypeId = (record.value.productTypeId == null || record.value.productTypeId == '') ? 2 : record.value.productTypeId;
    record.value.token = loginUser.token;
    if (record.invalid) {
      return;
    }
    else {
      this._partnerService.saveProduct(record.value).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("records save Sucessfully")
            this.formSubmitAttempt = false;
            this.isDisplayAddRecord = false;
            this.isDisplayRecordList = true;
            this.isDisplayUpdateRecord = false;
            this.getLaboratoryTest();
            this.itemForm.reset();
          }
          else {
            alert(data.returnMsg)

          }
        },
        error => {
          alert(error)
          console.log(error)
        });
    }
  }


  deleteProduct(record) {
    let confimationMessage = "Are you sure want to Delete " + record.name;
    if (confirm(confimationMessage)) {
      var loginUser = JSON.parse(localStorage.getItem('currentUser'));
      record.token = loginUser.token;
      this._partnerService.deleteProduct(record).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("Record updated sucessfully")

          }
          else {
            if (data.returnCode == 2) {

            }
          }
          this.cancelForm();
          this.selectedOption = 0;
         //this.getLaboratoryTest();
        },
        error => {
          alert(error)
          console.log(error)
        });

    }
    else {

    }
  }




  updateRecord(record) {
    this.formSubmitAttempt = true;
    var date = new Date();
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    record.value.productTypeId = (record.value.productTypeId == null || record.value.productTypeId == '') ? 2 : record.value.productTypeId;
    record.value.token = loginUser.token;
    if (record.invalid) {
      return;
    }
    else {
      this._partnerService.updateProduct(record.value).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("records updated Sucessfully")
            this.formSubmitAttempt = false;
            this.isDisplayAddRecord = false;
            this.isDisplayRecordList = true;
            this.isDisplayUpdateRecord = false;
            this.getLaboratoryTest();
          }
          else {
            alert(data.returnMsg)

          }
        },
        error => {
          alert(error)
          console.log(error)
        });
    }
  }

  searchProduct(searchValue) {
    if (searchValue) {
      this.laboratoryTestList = this.laboratoryProductList;
      this.laboratoryTestList = this.laboratoryTestList.filter(t => (t.name != null && t.name.toLowerCase().indexOf(searchValue) > -1) || (t.productType != null && t.productType.toLowerCase().indexOf(searchValue) > -1));

    }
    else {
      this.laboratoryTestList = this.laboratoryProductList;
    }
  }

  onSelectionChange(searchValue) {
    console.log('searchValue ', parseInt(searchValue));
    if (parseInt(searchValue) > 0) {
      this.laboratoryTestList = this.laboratoryProductList;
      this.laboratoryTestList = this.laboratoryTestList.filter(t => t.productTypeId == searchValue);
      this.selectedOption = this.laboratoryTestList[0].productTypeId;
    }
    else {
      this.laboratoryTestList = this.laboratoryProductList;
    }
  }

  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }

  }

  openSubscription(option:any){
    if(option == 0){
      this.activeSubscriptionOption = true;
    }
    else{
      this.activeSubscriptionOption = false;
    }
  }

  selectPrimary(data){
    if(data == 'family'){
      this.showFamilyMember = false;
      // this.subscriptionFor = 'family';
    }
    else{
      this.showFamilyMember = true;
      // this.subscriptionFor = 'primary';
    }
  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }
  uploadFileToActivity() {
    if (this.fileToUpload) {
      if (this.fileToUpload.type == "text/csv") {
        var loginUser = JSON.parse(localStorage.getItem("currentUser"));
        var form_data = new FormData();
        form_data.append("token", loginUser.token);
        form_data.append("files", this.fileToUpload);
        form_data.append("partnerid", loginUser.userDetail.partnerId);
        this._partnerService.fileUploadService(form_data).subscribe(
          (data) => {
            if (data["returnCode"] === 0) {
   
              alert("File successfully imported...");
            }
            // do something, if upload success
            location.reload();
            //this.router.navigate(['/coupon']);
        console.log("works");
          },
          (error) => {
            console.log(error);
            alert(error.error.returnMsg);
          }
        )
        alert("CSV file selected => "+this.fileToUpload.name)
      }
      else{
        alert("Not a csv file")
      }
    }
  }

  ngOnDestroy(){
    this.selectedOption = 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/laboratory-test/laboratory-test.component.ts